
/*
 * GABADINI SLEEP — CAMPAIGN IDENTITY
 * Stage 6A: Seven-day campaign persistence.
 *
 * Does not change cart contents or discounts.
 */

(() => {
  'use strict';

  const ACTIVE_KEY = 'gabadini-active-campaign-v1';
  const ACTIVATION_PREFIX = 'gabadini-campaign-start-v1:';
  const LEGACY_KEY = 'gabadini-campaign-identity-proof';
  const DURATION_MS = 7 * 24 * 60 * 60 * 1000;

  function getStatus() {
    const empty = {
      id: null,
      active: false,
      expired: false,
      activatedAt: null,
      expiresAt: null
    };

    try {
      const id = localStorage.getItem(ACTIVE_KEY);

      if (!id || !window.GabadiniCampaigns?.[id]) {
        return empty;
      }

      const activatedAt = Number(
        localStorage.getItem(ACTIVATION_PREFIX + id)
      );

      if (
        !Number.isSafeInteger(activatedAt) ||
        activatedAt <= 0
      ) {
        return empty;
      }

      const expiresAt = activatedAt + DURATION_MS;
      const now = Date.now();

      return {
        id,
        active: now >= activatedAt && now < expiresAt,
        expired: now >= expiresAt,
        activatedAt,
        expiresAt
      };
    } catch (error) {
      return empty;
    }
  }

  function getActive() {
    const status = getStatus();
    return status.active ? status.id : null;
  }

  function activateFromLandingPage() {
    const path = window.location.pathname.replace(/\/$/, '');

    const campaign = Object.values(
      window.GabadiniCampaigns || {}
    ).find(item => item.landingPath === path);

    if (!campaign) return;

    try {
      const key = ACTIVATION_PREFIX + campaign.id;

      const previousActivation = Number(
        localStorage.getItem(key)
      );

      const activationExpired =
  Number.isSafeInteger(previousActivation) &&
  previousActivation > 0 &&
  Date.now() >= previousActivation + DURATION_MS;

if (
  !Number.isSafeInteger(previousActivation) ||
  previousActivation <= 0 ||
  activationExpired
) {
  localStorage.setItem(key, String(Date.now()));
}

      localStorage.setItem(ACTIVE_KEY, campaign.id);

      const status = getStatus();

      console.log(
        'GABADINI: Campaign identity:',
        status
      );
    } catch (error) {
      console.warn(
        'GABADINI: Campaign identity storage unavailable.'
      );
    }
  }

  function clearTest() {
    try {
      const id = localStorage.getItem(ACTIVE_KEY);

      if (id) {
        localStorage.removeItem(
          ACTIVATION_PREFIX + id
        );
      }

      localStorage.removeItem(ACTIVE_KEY);
      sessionStorage.removeItem(LEGACY_KEY);
    } catch (error) {
      console.warn(
        'GABADINI: Could not clear test identity.'
      );
    }

    return getActive();
  }

  // Retire the original session-only proof.
  try {
    sessionStorage.removeItem(LEGACY_KEY);
  } catch (error) {
    // Storage may be unavailable.
  }

  // Detect campaign expiry while a storefront page
  // remains open. No cart or pricing changes here.
  let expiryTimer = null;
  let notifiedExpiry = null;

  function checkExpiry() {
    if (expiryTimer !== null) {
      clearTimeout(expiryTimer);
      expiryTimer = null;
    }

    const status = getStatus();

    if (status.active) {
      notifiedExpiry = null;

      const remaining = Math.max(
        0,
        status.expiresAt - Date.now()
      );

      expiryTimer = setTimeout(
        checkExpiry,
        remaining + 25
      );

      return;
    }

    if (
      status.expired &&
      notifiedExpiry !== status.expiresAt
    ) {
      notifiedExpiry = status.expiresAt;

      document.dispatchEvent(
        new CustomEvent('gabadini:campaign-expired', {
          detail: { campaign: status.id }
        })
      );

      console.log(
        'GABADINI: Campaign expired:',
        status.id
      );
    }
  }

  // Recheck when a suspended tab becomes active.
  window.addEventListener('focus', checkExpiry);

  document.addEventListener(
    'visibilitychange',
    () => {
      if (!document.hidden) checkExpiry();
    }
  );

  window.addEventListener('pageshow', checkExpiry);

  // Keep expiry detection aligned across browser tabs.
  window.addEventListener('storage', event => {
    if (
      event.key === ACTIVE_KEY ||
      event.key?.startsWith(ACTIVATION_PREFIX)
    ) {
      checkExpiry();
    }
  });

  window.GabadiniCampaignIdentity = {
    getActive,
    getStatus,
    clearTest
  };

  activateFromLandingPage();
  checkExpiry();
})();

